export default __webpack_public_path__ + "static/media/icon_svg_suitcase.2af4dd13.svg";